function PageLoading() {
  return (
    <div data-testid="pageLoading" className="antialiased">
      Loading page...
    </div>
  );
}

export { PageLoading };
